import get from 'lodash/get';
import {
    createSelector,
    OutputSelector,
} from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { ICaptchaState } from './captchaReducer';

export const captchaSelector = (state: IRootReducer) => get(state, 'captcha', {}) as ICaptchaState;

export const getCaptchaTime = () =>
    createSelector(
        captchaSelector,
        state => state.captchaTime,
    );

export const getCaptchaValue = (): OutputSelector<IRootReducer, string, (state: ICaptchaState) => string> =>
    createSelector(
        captchaSelector,
        state => state.value,
    );

export const getCaptchaIsOpen = (): OutputSelector<IRootReducer, boolean, (state: ICaptchaState) => boolean> =>
    createSelector(
        captchaSelector,
        state => state.isOpen,
    );

export const getCaptchaIsValid = (): OutputSelector<IRootReducer, boolean, (state: ICaptchaState) => boolean> =>
    createSelector(
        captchaSelector,
        state => state.isValid,
    );
